const info = {
    $schema: '../../chain.schema.json',
    chain_name: 'bfhevmtestnet',
    status: 'live',
    network_type: 'testnet',
    website: 'https://bfhaltruistic.com',
    pretty_name: 'BFH-EVM',
    chain_type: 'cosmos',
    chain_id: 'bfhevm_777-1',
    bech32_prefix: 'bfh',
    daemon_name: 'bfhevmd',
    node_home: '$HOME/.bfhevm',
    key_algos: ['ethsecp256k1'],
    extra_codecs: ['ethermint'],
    slip44: 60,
    fees: {
        fee_tokens: [{
                denom: 'abfh'
            }]
    },
    codebase: {
        git_repo: 'https://github.com/monk07-01/bfhevm',
        recommended_version: 'v1.0.0-tokenfactory-evm',
        compatible_versions: ['v1.0.0-tokenfactory-evm'],
        binaries: {
            "linux/amd64": 'https://github.com/monk07-01/bfhevm/releases/download/v1.0.0-tokenfactory-evm/bfhevm-linux-amd64',
            "darwin/arm64": 'https://github.com/monk07-01/bfhevm/releases/download/v1.0.0-tokenfactory-evm/bfhevm-darwin-arm64'
        },
        genesis: {
            genesis_url: 'https://raw.githubusercontent.com/monk07-01/bfhevm-testnets/master/bfhevm_777-1/genesis.json'
        }
    },
    logo_URIs: {
        png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/bfhevmtestnet/images/bfhevm.png'
    },
    apis: {
        rpc: [{
                address: 'https://rpc-bfhevm.xyz:8443',
                provider: 'bfhlabs'
            }],
        rest: [{
                address: 'https://rest-testnet-bfhevm.xyz:443',
                provider: 'bfhlabs'
            }],
        grpc: [{
                address: 'https://grpc-testnet-bfhevm.xyz:4430',
                provider: 'bfhlabs'
            }],
        "evm-http-jsonrpc": [{
                address: '_',
                provider: 'bfhlabs'
            }]
    },
    explorers: [{
            kind: 'BFH-DEXplorer',
            url: 'https://bfhaltruistic.com',
            tx_page: 'https://bfhaltruistic.com/blocks'
        }],
    images: [{
            png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/bfhevmtestnet/images/bfhevm.png'
        }]
};
export default info;
